<template>
  <div>
    <div class="seccion-titulo"><i class="bi bi-geo-alt me-2"></i>Destino</div>
    <div class="row g-3 mb-4">
      <div class="col-md-4">
        <label class="form-label form-label-sm">Departamento</label>
        <select class="form-select form-select-sm" v-model="destino.departamento_id" @change="cargarProvincias">
          <option value="" disabled>Seleccione</option>
          <option v-for="item in departamentos" :key="item.id" :value="item.id">{{ item.nombre }}</option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label form-label-sm">Provincia</label>
        <select class="form-select form-select-sm" v-model="destino.provincia_id" @change="cargarDistritos">
          <option value="" disabled>Seleccione</option>
          <option v-for="item in provincias" :key="item.id" :value="item.id">{{ item.nombre }}</option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label form-label-sm">Distrito</label>
        <select class="form-select form-select-sm" v-model="destino.distrito_id" @change="getPrecio()">
          <option value="" disabled>Seleccione</option>
          <option v-for="item in distritos" :key="item.id" :value="item.id">{{ item.nombre }}</option>
        </select>
      </div>
    </div>

    <div class="seccion-titulo"><i class="bi bi-calendar3 me-2"></i>Fechas</div>
    <div class="row g-3 mb-4">
      <div class="col-md-3">
        <label class="form-label form-label-sm">Fecha de salida</label>
        <input type="date" class="form-control form-control-sm" v-model="fechaSalida" @change="calcularFechaLlegada()" />
      </div>
      <div class="col-md-3">
        <label class="form-label form-label-sm">Fecha de llegada (aprox.)</label>
        <input type="date" class="form-control form-control-sm" readonly v-model="fechaLlegada" />
      </div>
      <div class="col-md-3">
        <label class="form-label form-label-sm">Lead Time (días)</label>
        <input type="number" class="form-control form-control-sm" :value="leadTime" disabled />
      </div>
    </div>

    <div v-if="tarifa" class="resultado-card">
      <div class="resultado-row resultado-final">
        <span class="resultado-label"><i class="bi bi-check-circle-fill me-1"></i>Precio final (sin IGV)</span>
        <span class="resultado-precio">S/ {{ tarifa }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  name: 'DocumentoTerrestre',
  data() {
    return {
      departamentos: [], provincias: [], distritos: [],
      destino: { departamento_id: '', provincia_id: '', distrito_id: '' },
      fechaSalida: '', fechaLlegada: '', leadTime: 0, tarifa: ''
    };
  },
  mounted() { this.cargarDepartamentos(); },
  methods: {
    async cargarDepartamentos() {
      try { const res = await axios.get('/departamentos'); this.departamentos = res.data; this.provincias = []; this.distritos = []; }
      catch (e) { console.error(e); }
    },
    async cargarProvincias() {
      try { this.distritos = []; const res = await axios.get('/provinciasByDepartamentos/' + this.destino.departamento_id); this.provincias = res.data; }
      catch (e) { console.error(e); }
    },
    async cargarDistritos() {
      try { const res = await axios.get('/distritosByProvincias/' + this.destino.provincia_id); this.distritos = res.data; }
      catch (e) { console.error(e); }
    },
    async getPrecio() {
      try {
        const { data } = await axios.get(`precio-consolidado-documentos/sobre_gestion/${this.destino.distrito_id}`);
        let lt = data.lead_time;
        this.leadTime = lt.includes('hora') ? parseInt(lt) / 24 : parseInt(lt);
        this.tarifa = data.costo;
        if (this.fechaSalida) this.calcularFechaLlegada();
      } catch (e) {
        if (e.response?.status === 404) { Swal.fire({ icon: 'warning', title: 'Sin tarifario', text: 'Comunicarse con el proveedor' }); this.leadTime = null; this.tarifa = null; }
        else Swal.fire({ icon: 'error', title: 'Error', text: 'Ocurrió un problema al consultar el precio.' });
      }
    },
    calcularFechaLlegada() {
      const llegada = new Date(new Date(this.fechaSalida).getTime() + parseInt(this.leadTime) * 86400000);
      this.fechaLlegada = llegada.toISOString().slice(0, 10);
    }
  }
};
</script>

<style scoped>
.seccion-titulo { font-size: 0.78rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.6px; color: #3f51b5; border-bottom: 2px solid #e8eaf6; padding-bottom: 6px; margin-bottom: 14px; }
.resultado-card { background: linear-gradient(135deg, #e8eaf6 0%, #f5f6ff 100%); border: 1px solid #c5cae9; border-radius: 10px; padding: 16px 20px; margin-top: 8px; }
.resultado-row { display: flex; justify-content: space-between; align-items: center; }
.resultado-final { border-top: 1px solid #c5cae9; padding-top: 10px; }
.resultado-label { font-size: 0.85rem; color: #5c6bc0; }
.resultado-precio { font-size: 1.4rem; font-weight: 800; color: #3f51b5; }
</style>
